import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { downloadCertificate, generateCertificate } from '../../services/Staff/Staff';


const ShowCertificate = () => {
    const [certificateUrl, setCertificateUrl] = useState();

    const [loading, setLoading] = useState(false);
    const [loadingCert, setLoadingCert] = useState(false);

    const { id } = useParams();

    const fetchData = async (id) => {
        setLoading(true)
        const data = await generateCertificate(id);
        if (data) {
            console.log("Staff data >>>", data);
            setCertificateUrl(data.data);
        }
        setLoading(false)

    };

    useEffect(() => {
        if (id) {
            fetchData(id);
        }
    }, []);

const handleDownload = async () => {
    setLoadingCert(true)
     const blobUrl = `${process.env.REACT_APP_BUCKET_URL}${certificateUrl}`;
   fetch(blobUrl)
  .then(response => response.blob())
  .then(blob => {
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = "certificate.png"; 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);
    setLoadingCert(false)

  })
  .catch(error => {
    console.error("Download failed:", error);
  });
}

    return (
        <div className="management-container">
            {
                loading ?
                    <div className="col-md-12" style={{ height: '40vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div class="spinner-border spinner-border-sm" role="status"></div>
                    </div>
                    :
                    <div style={{ padding: '40px', width: '100%' }}>
                        <div
                            style={{
                                background: '#fff',
                                padding: '24px',
                                borderRadius: '12px',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
                                maxWidth: '900px',
                                margin: 'auto',
                                textAlign: 'center',
                                position: 'relative'
                            }}
                        >
                            <a
                                href=""
                                download="certificate.jpg"
                                className="btn btn-custom "
                                onClick={ (e) => {
                                    e.preventDefault();
                                    handleDownload()
                                   
                                }}
                                style={{
                                    position: 'absolute',
                                    top: '25px',
                                    right: '16px',
                                    padding: '8px 16px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    borderRadius: '6px',
                                    textDecoration: 'none',
                                    fontWeight: '500',
                                    fontSize: '14px',
                                }}
                                
                            >
                               {loadingCert ? "loading..." : "Download"} 
                            </a>

                            <h2 style={{ marginBottom: '20px', fontWeight: 600 }}> Certificate</h2>

                            {/* For image certificate */}
                            <img
                                src={`${process.env.REACT_APP_BUCKET_URL}${certificateUrl}`}
                                alt="Certificate"
                                style={{
                                    width: '100%',
                                    // maxHeight: '700px',
                                    objectFit: 'contain',
                                    border: '1px solid #ddd',
                                    borderRadius: '8px',
                                }}
                            />

                        </div>
                    </div>


            }
        </div>

    );
};

export default ShowCertificate;
